export class GroupeVarietalVariete {
    static jsonMap = {
        id: 'id',
        idVariete: 'idVariete',
        libelle: 'libelle',
        idGroupeVarietal: 'idGroupeVarietal'
    };

    id: number;
    idVariete: number;
    libelle: string;
    idGroupeVarietal: number;
}
